import styled, { css } from 'styled-components';
import { Icon as IconComponent } from 'src/components';

export const DevToolsButton = styled.button(
  ({ theme }) => css`
    position: fixed;
    width: ${theme.sz.s12};
    height: ${theme.sz.s12};
    top: ${theme.sz.s20};
    right: ${theme.sz.s4};
    border-radius: ${theme.sz.s2};
    background-color: ${theme.co.secondary20};
    border: none;
    z-index: ${theme.zi.debug};

    &:hover {
      cursor: pointer;
    }
  `,
);

export const Icon = styled(IconComponent)(
  ({ theme }) => css`
    font-size: ${theme.DEPRECATED_ty.largest};
    color: ${theme.co.neutral99};
  `,
);
